import './instrument' // Sentry must init before any other code
import * as Sentry from '@sentry/react'
import { createRoot } from 'react-dom/client'
import { withLDProvider } from 'launchdarkly-react-client-sdk'

import App from './App.tsx'
import { hasLocalFeatureFlags, localFeatureFlags } from './utils/localFeatureFlags'

const ldClientId = import.meta.env.VITE_LAUNCHDARKLY_CLIENT_ID
const shouldUseLdProvider = Boolean(ldClientId || hasLocalFeatureFlags)

const RootApp = shouldUseLdProvider
  ? withLDProvider({
      // Allow local feature-flag bootstrapping even when no LD client ID is configured.
      clientSideID: ldClientId || 'local-dev-client-id',
      reactOptions: { useCamelCaseFlagKeys: true },
      context: { kind: 'user', key: 'anonymous', anonymous: true },
      options:
        hasLocalFeatureFlags || !ldClientId
          ? {
              bootstrap: localFeatureFlags,
              // With no client ID there is nothing to talk to: the browser SDK has no
              // `offline` switch, so silence it explicitly instead. Without this it polls
              // and re-opens its event stream against the placeholder ID forever (404/401),
              // which is enough reconnect traffic to starve the tab.
              ...(ldClientId ? {} : { streaming: false, sendEvents: false, fetchGoals: false }),
            }
          : undefined,
    })(App)
  : App

createRoot(document.getElementById('root')!, {
  onUncaughtError: Sentry.reactErrorHandler(),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(<RootApp />)
